import {Swiper} from "swiper";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import lightGallery from 'lightgallery';
export class SwiperJS {

    constructor() {
        this.init_swiper();
        this.init_light_gallery();
    }

    init_swiper () {
        const swiper = new Swiper('.swiper', {
            modules: [Autoplay],
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            }
        });
    }

    init_light_gallery () {
        lightGallery(document.getElementById('swiper_gallery'), {
            selector: ".swiper-slide-inner",
            licenseKey: 'C7228D44-476A-4BA5-A691-FA3370B257C1',
            speed: 500,
        });
    }

}